import { render } from "./myDeposit.vue?vue&type=template&id=09747a63&scoped=true"
import script from "./myDeposit.vue?vue&type=script&lang=js"
export * from "./myDeposit.vue?vue&type=script&lang=js"

import "./myDeposit.vue?vue&type=style&index=0&id=09747a63&lang=scss&scoped=true"
import "./myDeposit.vue?vue&type=style&index=1&id=09747a63&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09747a63"]])

export default __exports__